import React, { FC, useEffect, useMemo } from 'react';
import _ from 'lodash';
import { useTranslation } from 'react-i18next';
import { useFilters } from '../../../hooks/useFilters';
import { ICategory } from '../../../services/groupComparison';
import { CategoriesResultsCont } from '../GroupComparisonTable.styles';
import {
  CategoryHeader,
  ColumnName,
  GroupInfoHeader,
  HeaderCont,
  KpiHeader,
  ReportHeader,
  ResponseRateHeader,
  RiskHeader,
  TeamHeader
} from './GroupComparisonTableHeader.styles';

interface IGroupComparisonTableHeader {
  categories: ICategory[];
  isKpiAvailable: boolean;
  isRiskAvailable: boolean;
}

const GroupComparisonTableHeader: FC<IGroupComparisonTableHeader> = ({
  categories, isKpiAvailable, isRiskAvailable
}) => {
  const {t} = useTranslation();
  const {currentFilters} = useFilters();
  const sortFilter = typeof currentFilters?.compareSort === 'string' ? JSON.parse(currentFilters?.compareSort) : {};
  const activeSortKey = Object.keys(sortFilter).length > 0 ? Object.keys(sortFilter)[0] : '';
  const transformedActiveSortKey = activeSortKey.split(' ').join('').toLowerCase();

  const detectScroll = () => {
    const header = document.getElementById('HeaderCont');
    if(header){
      const sticky = header.offsetTop;
      if (window.pageYOffset > sticky) {
        header.classList.add('sticky');
      } else {
        header.classList.remove('sticky');
      }}
  };

  useEffect(() => {
    document.addEventListener('scroll', detectScroll);
    return () => {
      document.removeEventListener('scroll', detectScroll);
    };
  },[]);
  const teamActiveCondition = transformedActiveSortKey === 'team' || transformedActiveSortKey === '';
  const renderCategoriesHeaders = useMemo(() => {
    return categories.map((category, index) => {
      return (
        <CategoryHeader
          id="CategoryHeader"
          key={category.code}
          index={index}
          categoryAmount={categories.length}
        >
          <ColumnName
            id="ColumnName"
            sortActive={activeSortKey === category.code}
          >
            {category.title}
          </ColumnName>
        </CategoryHeader>
      );});
  }, [categories]);

  return (
    <HeaderCont id="HeaderCont" data-testid="groupComparisonHeader">
      <GroupInfoHeader id="GroupInfoHeader">
        <TeamHeader id="TeamHeader">
          <ColumnName
            id="ColumnName"
            sortActive={teamActiveCondition}
          >{t('report.groupComparison.team')}
          </ColumnName>
        </TeamHeader>
        <ResponseRateHeader id="ResponseRateHeader">
          <ColumnName
            id="ColumnName"
            sortActive={transformedActiveSortKey === 'responserate'}
          >{t('report.groupComparison.responseRate')}</ColumnName>
        </ResponseRateHeader>
        {isRiskAvailable &&
      <RiskHeader id="RiskHeader">
        <ColumnName
          id="ColumnName"
          sortActive={transformedActiveSortKey === 'risk'}
        >{t('report.groupComparison.risk')}</ColumnName>
      </RiskHeader>}
        {isKpiAvailable &&
      <KpiHeader id="KpiHeader">
        <ColumnName
          id="ColumnName"
          sortActive={transformedActiveSortKey === 'kpi'}
        >{t('report.groupComparison.kpi')}</ColumnName>
      </KpiHeader>}
      </GroupInfoHeader>
      <CategoriesResultsCont id="CategoriesHeadersCont">
        {renderCategoriesHeaders}
      </CategoriesResultsCont>
      <ReportHeader id="ReportHeader">
        <ColumnName id="ColumnName">{t('report.groupComparison.report')}</ColumnName>
      </ReportHeader>
    </HeaderCont>
  );
};

export default GroupComparisonTableHeader;
